import { createToken } from "@tylertech/smart-pulse-core";
import type { AgentToolProvider } from "@tylertech/smart-pulse-core";

/** DI token for the CX escalation tool provider within the Smart Pulse container (not Angular DI). */
export const CX_ESCALATION_PROVIDER_TOKEN = createToken<AgentToolProvider>("CxEscalationProvider");
